import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import TextInput from "../../common/TextInput";
import { ADD_SERVICE_ACCOUNT } from "../../appConstants";
import { toast } from "react-toastify";
import axiosInstance from "../AxiosInstance/AxiosInstance";

const AddServiceAccount = ({
  ModalState,
  handleClose,
  setServiceAccountUpdate,
}) => {
  const [formData, setFormData] = useState({
    identifier: "",
    platform_url: "",
    access_token: "",
    secret_key: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    boxShadow: "0 0 6px 0 rgba(149,149,149,0.5)",
  };

  const handleChange = ({ target: { id, value } }) => {
    setFormData((prev) => ({ ...prev, [id]: value }));
    setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const addServiceAccountFields = [
    "identifier",
    "platform_url",
    "access_token",
    "secret_key",
  ];

  const validateForm = () => {
    const newErrors = {};

    addServiceAccountFields.forEach((field) => {
      if (!formData[field])
        newErrors[field] = `${field.replace("_", " ")} is required`;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddServiceAccount = async () => {
    setIsSubmitting(true);

    try {
      const { data } = await axiosInstance.post(ADD_SERVICE_ACCOUNT, formData, {
        headers: { Authorization: `Bearer ${localStorage?.access_token}` },
      });

      if (data?.status) {
        toast.success(data.message, { position: toast.POSITION.BOTTOM_CENTER });
        setServiceAccountUpdate((state) => !state);
        setTimeout(handleClose, 1000);
      } else {
        toast.error(`Error: ${data?.message || "Unknown error occurred"}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } catch (error) {
      toast.error(
        `Error: ${
          error.response?.data?.message || error.message || "Request failed"
        }`,
        { position: toast.POSITION.BOTTOM_CENTER }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) handleAddServiceAccount();
  };

  return (
    <Modal className="Backdrop" open={ModalState} onClose={handleClose}>
      <Box sx={modalStyles} id="add-service-account-modal">
        <div
          className="d-flex justify-content-between align-items-center"
          id="add-service-account-header"
        >
          <h5 className="font-weight-bold mt-2" id="add-service-account-title">
            Add Service Account
          </h5>
          <IconButton
            id="add-service-modal-close-button"
            className="text-light"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </div>
        <form
          onSubmit={handleSubmit}
          className="my-4 rounded"
          id="add-service-account-form"
        >
          {addServiceAccountFields.map((field) => (
            <TextInput
              key={field}
              label={field.replace("_", " ").toUpperCase()}
              id={field}
              onChange={handleChange}
              error={errors[field]}
              value={formData[field]}
              required
            />
          ))}
          <div className="text-center mt-2">
            <button
              type="submit"
              className="btn-class"
              disabled={isSubmitting}
              id="add-service-submit-button"
            >
              {isSubmitting ? "Submitting..." : "SUBMIT"}
            </button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default AddServiceAccount;
